// Utility to get initials from a name
export function getInitials(name?: string) {
    return name
        ? name
              .split(" ")
              .map((n) => n[0])
              .join("")
              .toUpperCase()
        : "U";
}
